export const BREADCRUMB_KEYS = {
  home: 'common.label.home',
  jobs: 'common.label.jobs',
  applications: 'common.label.applications',
  jobseekers: 'common.label.jobseekers',
  analytics: 'common.label.analytics',
  login: 'common.label.login',
  resetPassword: 'common.label.resetPassword',
  setupPassword: 'common.label.setupPassword',
  employmentConfirmation: 'common.label.employmentConfirmation',
  editJob: 'page.editJob.title'
} as const;

export type BreadcrumbKey =
  (typeof BREADCRUMB_KEYS)[keyof typeof BREADCRUMB_KEYS];

export const isI18nKey = (value?: string): value is BreadcrumbKey => {
  if (!value) return false;
  return value.includes('.') && !/\s/.test(value);
};
